import React, { useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import config from "../../config";

const PasswordProtectionModal = ({ 
  isOpen, 
  section, 
  onClose, 
  onSuccess,
  redirectUrl 
}) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVerify = async () => {
    const user = JSON.parse(localStorage.getItem("ship_rocket_user"));
    
    try {
      setLoading(true);
      const res = await axios.post(
        `${config.apiUrl}/user/verify_section_password`,
        {
          customer_id: user.customer_id,
          password: (password), // Hash before sending
          section
        },
        { headers: config.headers }
      );

      if (res.data.message === "Access granted") {
        // Store verification in localStorage
        localStorage.setItem(
          `section_access_${section}`,
          JSON.stringify({
            verified: true,
            expires_at: res.data.expires_at
          })
        );
        
        onSuccess();
        if (redirectUrl) {
          window.location.href = redirectUrl;
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: err.response?.data?.message || "Password Not Matched",
        toast: true,
        timer: 3000,
        position: "bottom-end",
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {isOpen && (
        <>
          <div className="modal-backdrop show"></div>
          <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    {section === "profile" ? "Profile" : section.charAt(0).toUpperCase() + section.slice(1)} is Password Protected
                  </h5>
                  <button 
                    type="button" 
                    className="btn-close" 
                    onClick={onClose}
                    disabled={loading}
                  />
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Enter Password</label>
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter your password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleVerify()}
                      autoFocus
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button 
                    className="btn btn-secondary" 
                    onClick={onClose}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                  <button 
                    className="btn btn-primary" 
                    onClick={handleVerify}
                    disabled={loading || !password}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2"></span>
                        Verifying...
                      </>
                    ) : "Continue"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PasswordProtectionModal;